import React from "react";
import './subject-selection-screen.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import SessionCache from "../../routes/session-cache";
import CommonApi from "../../../apis/common";
import Path from "../../routes/routes-path";

class SubjectSelectionScreen extends React.Component {

    state = {
        showSubjectSelection: true,

    }

    constructor(props) {
        super(props)
        this.userInfo = SessionCache.getUser()
        console.log(this.userInfo, this.state.selectedSubjectId)
        this.state.subjectsList = this.userInfo.schoolInfo?.subjects
    }

    onSelectSubject(subject, index) {
        let payload = {
            subjectId: subject.value,
            subjectName: subject.title
        }
        CommonApi.updateStaffSubjectInfo(payload).then(res => {
            console.log(res)
            this.setState({ selectedSubjectId: subject.value, selectedIndex: index, showSubjectSelection: false }, () => {
                let userInfo = this.userInfo
                userInfo.subjectId = subject.value
                userInfo.subjectName = subject.title
                SessionCache.setUser(userInfo)
                this.props.history.replace(Path.DASHBOARD)
            })
        }).catch(err => {
            console.log(err)
        })
    }


    render() {
        return (
            <div className="subject-selection-screen">
                {
                    this.state.showSubjectSelection ?
                        <div className="select-subject-screen">
                            <div className="text-center select-subject-text pt-5">Select a Subject</div>
                            <div className="mt-5">
                                {
                                    this.state.subjectsList && this.state.subjectsList.length ?
                                        <div className="d-flex justify-content-center">
                                            {this.state.subjectsList.map((subject, index) => (
                                                <div className="mr-5 mb-5 d-flex justify-content-center align-items-center subject-card cursor-pointer"
                                                    onClick={() => this.onSelectSubject(subject, index)}>
                                                    <div className="radio-button-wrapper mr-3 d-flex align-items-center justify-content-center">
                                                        {this.state.selectedSubjectId === subject.value ? <div className="radio-selected"></div> : <></>}
                                                    </div>
                                                    <div className="mr-3"><img className="image-size" src={getImageSource(subject.title === 'MATHS' ? ImageConstants.MATHS_ICON : subject.title === 'SCIENCE' ? ImageConstants.SCIENCE_ICON : ImageConstants.MATHS_ICON)} /></div>
                                                    <div className="subject-text">{subject.title}</div>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <div className="text-center mt-3">No Subjects Found</div>
                                }
                            </div>
                        </div>
                        :
                        <>No Subjects Found 1</>
                }
            </div>
        )
    }

}

export default SubjectSelectionScreen;